import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading || user === null) {
    return (
      <div
        className="min-h-screen flex items-center justify-center"
        style={{ background: "var(--ink)" }}
      >
        <div className="font-mono text-xs uppercase tracking-[0.25em] text-[var(--mute)]">
          Verifying credentials…
        </div>
      </div>
    );
  }

  if (!user || user.role !== "admin") {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
}
